export const IOS_IN_CALL_DISPLAY_NAME = "In call";
export const IOS_IN_CALL_ICON_SLUG = "incall";

function normalizeInCallToken(value: string): string {
  return value.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
}

function matchesInCallToken(value: string): boolean {
  return normalizeInCallToken(value) === "incallservice";
}

export function isIosInCallService(
  appIdentifier?: string | null,
  displayName?: string | null,
): boolean {
  for (const value of [appIdentifier, displayName]) {
    const trimmed = (value ?? "").trim();
    if (!trimmed) continue;

    const lastSegment = trimmed.split(".").pop() ?? "";
    if (matchesInCallToken(lastSegment)) return true;

    if (!trimmed.includes(".") && matchesInCallToken(trimmed)) return true;
  }

  return false;
}
